import React, { useState, memo } from 'react';
import { Layout } from 'antd';
import { PropTypes } from 'prop-types';
import Sider from './Sider';
import Header from './Header';
import Footer from './Footer';
import { LayoutWrapper } from './styled';
import { Outlet, useNavigate } from 'react-router-dom';
import RequireAuth from '../RequireAuth';
import { useGetAuthen } from 'client/hook/user';
import { getUserInfo } from 'features/common/commonSlice';
import { useEffect } from 'react';
import useLogged from 'hooks/useLogged';
import { useAppDispatch } from 'app/store';
import { message } from 'antd';
import { _removeToken } from 'utils/cookie-token';
import { Suspense } from 'react';
import { Spin } from 'antd';

const { Content } = Layout;

function Index() {
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isLogged = useLogged();
  const { data: userInfo } = useGetAuthen({}, !!isLogged);

  useEffect(() => {
    if (isLogged) {
      dispatch(getUserInfo());
    }
  }, [isLogged]);

  // Check role user
  useEffect(() => {
    const { role_name } = userInfo;

    if (role_name && ['FREE_USER', 'VIP_USER'].includes(role_name)) {
      message.warning(
        'Bạn không có quyền truy cập. Vui lòng liên hệ với admin để biết thêm chi tiết!'
      );
      _removeToken();
      navigate(`/login?redirectUrl=${window.location.href}`);
    }
  }, [userInfo.role_name]);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  return (
    <RequireAuth>
      <LayoutWrapper>
        <Layout>
          <Sider collapsed={collapsed} toggleCollapsed={toggleCollapsed} />
          <Layout style={{ marginLeft: collapsed ? '80px' : '200px', transition: 'all 0.2s' }}>
            <Header />
            <Content>
              <Suspense
                fallback={
                  <div
                    style={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                    <Spin />
                  </div>
                }>
                <Outlet />
              </Suspense>
            </Content>
            <Footer />
          </Layout>
        </Layout>
      </LayoutWrapper>
    </RequireAuth>
  );
}

Index.propTypes = {
  children: PropTypes.element
};

export default memo(Index);
